export * from './client'

export type TypedEnumUnion<T extends string> = `${T}`;

export enum WsNamespaces {
	Client = 'client',
	Ocpp = 'OCPP',
  Ocpi = 'OCPI',
  /** OICP gateway connects to backend on this namespace for events and commands */
  Oicp = '/oicp',
}

export function getNamespacesArray() {
	const namespaces: WsNamespaces[] = [];
	for (const index in WsNamespaces) {
		namespaces.push(WsNamespaces[index]);
	}
	return namespaces;
}
